import {useStore} from "../hooks/store";
import {Modal} from "@wordpress/components";
import BBCode from '@bbob/react';
import presetReact from "@bbob/preset-react";

const plugins = [presetReact()];

export const BlocksPopup = ({ open, closeCallback }) => {

    const simulation = useStore((state) => state.simulation);

    const blocks = simulation.displayBlocks;
    const legalMentions = simulation.globalText.legalMention;

    function formatBlockLine (line) {

        let classes = ["simulationRow"];
        if(line.styleType.bold) {
            classes.push('simulationRowBold');
        }
        if(line.styleType.italic) {
            classes.push('simulationRowItalic');
        }
        if(line.styleType.underlined) {
            classes.push('simulationRowUnderlined');
        }
        if(line.styleType.indent) {
            classes.push('simulationRowIndent');
        }

        classes.push('simulationRowSize' + line.styleType.displaySize);
        return (
            <div className={classes.join(' ')}>
                <div className="simulationRowTitle">{line.label}</div>
                <div className="simulationRowValue">{line.hasOwnProperty('displayValue') ? line.displayValue : ''}</div>
            </div>
        );
    }

    return (
        <>
        {
            open && (
                <Modal size={"medium"} className="modal occasionsSearchEngineModal simulationModal" isDismissible={false} onRequestClose={closeCallback}>
                    <h3>Détails du financement</h3>
                    <div className="occasionsSearchEngineModalContent simulationRows">
                        <div className="simulationProduct">{simulation.globalText.financialProductLabel.text}</div>
                        {
                            blocks.map((block) => block.displayLines.map((line) => formatBlockLine(line)))
                        }
                        <div className="simulationLegalMentions">
                            {
                                legalMentions.map((mention) =>
                                    <BBCode plugins={plugins} container={'p'}>{mention.text}</BBCode>
                                )
                            }
                        </div>
                    </div>
                    <div className="occasionsSearchEngineModalFooter">
                        <button type="button" onClick={closeCallback}>Fermer</button>
                    </div>
                </Modal>
            )
        }
        </>
    )
}